import { CachePolicy } from 'contentstack';
import { unstable_cache } from 'next/cache';

import {
    ContentStack,
    ContentStackLivePreview,
} from '@nxt-costco-com/forge-digital-components';
import type { ContentTypeProps } from '@nxt-costco-com/forge-digital-components';

const _getConfigurationByTitle = async <T>(
    contentType: ContentTypeProps,
    title: string,
    enableLivePreview = false,
): Promise<T> => {
    let stackClient = ContentStack;

    if (enableLivePreview) {
        stackClient = ContentStackLivePreview;
        stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
    }

    try {
        const query = stackClient.stack
            .ContentType(contentType)
            .Query()
            .where('title', title)
            .toJSON()
            .findOne();
        const result = await query;
        return result;
    } catch (err) {
        throw new Error(
            `An error occurred in function _getConfigurationByTitle: ${err}`,
        );
    }
};

const cached_getConfigurationByTitle = unstable_cache(
    _getConfigurationByTitle,
    ['search_getConfigurationByTitle'],
    { revalidate: 1800 },
);

export const getConfigurationByTitle = async <T>(
    contentType: ContentTypeProps,
    title: string,
    enableLivePreview = false,
): Promise<T> => {
    const fn =
        typeof window === 'undefined'
            ? cached_getConfigurationByTitle
            : _getConfigurationByTitle;

    return fn(contentType, title, enableLivePreview);
};
